/* eslint-disable no-undef */
import React, { Component } from 'react';
import { countryMetaData as countries } from '../../utils/spaConstants';
import { formatName } from '../../utils/spaUtils';
import LoaderImg from '../../images/ajax_loader.gif';
import { initHostedSession } from '../../utils/spaUtils';
import Popup from 'reactjs-popup';
import amexImage from '../../images/amex_card.jpg';
import mastercardImage from '../../images/master_card.jpg';
import { stateCountries, months, years, districts, zones } from '../../utils/paymentConstants';

let validateRules = {
    Email: {
        required: true,
        email: true,
    },
    FirstName: {
        required: true,
        validname: true,
    },
    LastName: {
        required: true,
        validname: true,
    },
    countryCode: {
        required: true,
    },
    City: {
        required: true,
    },
    PostCode: {
        required: true,
    },
    Address: {
        required: true,
        validaddress: true,
    },
    stateCode: {
        required: true,
    },
    cardHolder_radio: {
        required: true,
    },
};

let validateMsgs = {
    FirstName: {
        required: 'First Name is required',
        validname: 'Letters, hyphens, periods, single quotes and spaces only please. ',
    },
    LastName: {
        required: 'Last Name is required',
        validname: 'Letters, hyphens, periods, single quotes and spaces only please. ',
    },
    Email: {
        required: 'Email is required',
        email: 'Invalid Email',
    },
    countryCode: {
        required: 'Country is required',
    },
    City: {
        required: 'City is required',
    },
    PostCode: {
        required: 'Zip/Postal Code is required',
    },
    Address: {
        required: 'Address is required',
        validaddress: 'Please enter a valid address. ',
    },
    stateCode: {
        required: 'State/Province is required',
    },
    cardHolder_radio: {
        required: 'Select a card holder',
    },
};

class PaymentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            country: '',
            _states: '',
        };
    }
    help = (e) => e.preventDefault();

    componentDidMount() {
        initHostedSession(this.handleSubmitForm.bind(this), this.validateForm);

        // adding this jquery similar to docroot for quick fix
        $(function() {
            $.validator.addMethod(
                'validname',
                function(value, element) {
                    return this.optional(element) || /^[a-zA-Z\-.'\s]+$/i.test(value);
                },
                'Letters, hyphens, periods, single quotes and spaces only please. ',
            );

            $.validator.addMethod(
                'validaddress',
                function(value, element) {
                    return this.optional(element) || /^[a-zA-Z0-9\s&#,.:'\-\/]*$/i.test(value);
                },
                'Please enter a valid address. ',
            );
        });
    }
    errorPlacement = (error, element) => {
        error.addClass('form-field-msg');
        error.attr('role', 'alert');
        error.attr('aria-invalid', true);
        error.attr('data-test-id', `${element.attr('name')}-error-msg`);
        if (element[0] && element[0].name === 'cardHolder_radio') {
            error.appendTo(element.closest('div'));
        } else {
            error.appendTo(element.closest('span'));
        }
    };
    invalidHandler() {
        console.log('invalid handler');
    }
    handlePayment = () => {
        $('#spa-payment-form').validate({
            rules: validateRules,
            messages: validateMsgs,
            errorPlacement: this.errorPlacement,
            invalidHandler: this.invalidHandler,
        });
        paymentAuth.pay();
    };

    validateForm() {
        let isValid = $('#spa-payment-form').valid();

        //   let errorNode = document.querySelector('input.error');
        //   errorNode = errorNode || document.querySelector('select.error');
        //   if(errorNode)
        //     errorNode.focus();
        // $('form input.error:first,form select.error:first').parent().find('a,input,select,textarea,button').last().focus();
        let errorDom = $('form .error:not(label)').get(0);
        if (errorDom)
            $(errorDom)
                .parent()
                .find('a,input,select,textarea,button')
                .last()
                .focus();
        return isValid;
    }

    handleSubmitForm = () => {
        let cardData = {};
        cardData.CardNumber = $('#cardNumber-mc').val();
        cardData.cardStringType = $('[type=hidden]#cardStringType').val();
        cardData.fundsType = $('#fund-type').val();
        cardData.maskedCardNumber = $('#maskedCardNumber').val();
        cardData.CardCode = '';
        cardData.cardType = $('#cardType-mc').val();
        this.props.handlePayment(cardData);
    };

    componentDidUpdate() {
        if (!PaymentSession) {
            initHostedSession(this.handleSubmitForm.bind(this), this.validateForm);
        }
    }

    getStatesByCountry(country) {
        for (var i = 0; i < stateCountries.length; i++) {
            if (country === stateCountries[i].v) return stateCountries[i].states;
        }
        return null;
    }

    helpPopUp = (
        <div
            className="mfp-wrap  mfp-close-btn-in mfp-align-top mfp-auto-cursor border-box-sizing mfp-ready"
            tabindex="-1"
            style={{ overflow: 'hidden scroll' }}
            aria-label="Credit Card Information: Security Code"
            role="dialog">
            <div className="mfp-container mfp-ajax-holder mfp-s-ready">
                <div className="mfp-content">
                    <div id="popupContainer" className="container">
                        <div id="popupTitleArea">
                            <span className="ir seawitch"> </span>
                            <h2 className="title">Credit Card Information: Security Code</h2>
                        </div>
                        <div id="popupContent" className="col-xs-12">
                            <div className="row">
                                <div className="col-xs-6">
                                    <h3>Visa, Master Card, Discover, &amp; Diners Club</h3>
                                    <img
                                        alt="Visa, Master Card, Discover, &amp; Diners Club"
                                        src={mastercardImage}
                                        title="Visa, Master Card, Discover, &amp; Diners Club"
                                        width="100%"
                                    />
                                    <p>
                                        {' '}
                                        You will find a 3 - digit security code on the back of the
                                        card.It is not embossed like the card number, and is always
                                        the final group of numbers printed on the back on or near
                                        the signature panel of the card.{' '}
                                    </p>
                                </div>
                                <div className="col-xs-6">
                                    <h3> American Express </h3>
                                    <img
                                        alt="American Express"
                                        src={amexImage}
                                        title="American Express"
                                        width="100%"
                                    />
                                    <p>
                                        American Express cards have a 4-digit code printed on the
                                        front side of the card above the number. It is printed flat,
                                        not embossed like the card number.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="mfp-close-wrapper">
                            <div className="mfp-close-inner-wrapper">
                                <button
                                    title="Close(Esc)"
                                    className="mfp-close icon-no-text"
                                    data-test-id="mfp-close"
                                    onClick={this.onCloseHelp.bind(this)}>
                                    <svg className="svg-icon svg-icon-open-close">
                                        <use xlinkHref="#icon-open-close"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    onCloseHelp(e) {
        e.preventDefault();
        this.refs.helpPopUp.closePopup();
    }
    render() {
        let {
            payer = {},
            isPayLoading,
            cartPrice,
            handleInputChange,
            selectGuestPayer,
            guestDetails,
            ShipboardCurrencyCode,
        } = this.props;
        let { _states, country } = this.state;
        let ageOver12Guests = guestDetails.filter((guest) => guest.PassengerDetail.Age > 12);
        return (
            <form id="spa-payment-form">
                <div className="row form-field" data-test-id="billing-text">
                    <span className="font-size-p0 gotham-bold">
                        Please enter your billing information as it appears on your credit card
                        statement:
                    </span>
                </div>
                <div
                    className="row form-field  required-field rowPaddingAdjust"
                    data-test-id="cardholder-label">
                    <label className="form-field">
                        <sup className="required">*</sup>Choose cardholder:
                    </label>
                    {ageOver12Guests.length > 0 &&
                        ageOver12Guests.map((guest) => {
                            let { Name } = guest.PassengerDetail,
                                paxId = guest.PaxId,
                                nameLabel = formatName(`${Name.FirstName} ${Name.LastName}`);
                            return (
                                <span className="form-field radio reduce-spacing">
                                    <input
                                        type="radio"
                                        onChange={() => {
                                            selectGuestPayer(guest);
                                            let country =
                                                guest.PassengerDetail.Address.CountryId || '';
                                            let _states = this.getStatesByCountry(country) || [];
                                            this.setState(
                                                {
                                                    country:
                                                        guest.PassengerDetail.Address.CountryId,
                                                    _states,
                                                },
                                                () => {
                                                    let payer = {};
                                                    payer.isCardHoldSelected = 'true';
                                                    payer.paymentType = 'credit-card';
                                                    payer.FirstName =
                                                        guest.PassengerDetail.Name.FirstName;
                                                    payer.countryCode =
                                                        guest.PassengerDetail.Address.CountryId;
                                                    payer.LastName =
                                                        guest.PassengerDetail.Name.LastName;
                                                    payer.Email = guest.PassengerDetail.Email;
                                                    payer.Address =
                                                        guest.PassengerDetail.Address.Line1;
                                                    payer.Address2 =
                                                        guest.PassengerDetail.Address.Line2;
                                                    payer.PostCode =
                                                        guest.PassengerDetail.Address.PostCode;
                                                    payer.stateCode =
                                                        guest.PassengerDetail.Address.StateId;
                                                    payer.City = guest.PassengerDetail.Address.City;
                                                    this.props.setPayer(payer);
                                                },
                                            );
                                        }}
                                        value={paxId}
                                        data-test-id="passenger-radio"
                                        id={`passenger${paxId}_radio`}
                                        name="cardHolder_radio"
                                    />
                                    <label className="" htmlFor={`passenger${paxId}_radio`}>
                                        {nameLabel}
                                    </label>
                                </span>
                            );
                        })}

                    <span className="form-field radio reduce-spacing">
                        <input
                            type="radio"
                            onChange={() =>
                                this.setState({ country: '', _states: [] }, () => {
                                    selectGuestPayer('Not_in_booking');
                                    let payer = {};
                                    payer.countryCode = '';
                                    payer.isCardHoldSelected = 'true';
                                    payer.stateCode = '';
                                    payer.paymentType = 'credit-card';
                                    this.props.setPayer(payer);
                                })
                            }
                            data-test-id="cardholder-radio"
                            name="cardHolder_radio"
                            id="nonPassenger_radio"
                        />
                        <label className="" htmlFor="nonPassenger_radio">
                            Cardholder not on this booking
                        </label>
                    </span>
                    <span className="card-holder-error"></span>
                </div>
                <div className="row">
                    <span className="form-field required-field" data-test-id="first-name">
                        <label htmlFor="FirstName">
                            <sup className="required">*</sup>First Name
                        </label>
                        <input
                            required
                            className="inputEleWidth"
                            type="text"
                            name="FirstName"
                            id="FirstName"
                            onChange={handleInputChange}
                            value={payer.FirstName || ''}
                        />
                    </span>
                </div>
                <div className="row">
                    <span className="form-field required-field" data-test-id="last-name">
                        <label htmlFor="lastName">
                            <sup className="required">*</sup>Last Name
                        </label>
                        <input
                            required
                            className="inputEleWidth"
                            type="text"
                            name="LastName"
                            id="lastName"
                            onChange={handleInputChange}
                            value={payer.LastName || ''}
                        />
                    </span>
                </div>
                <div className="row">
                    <span className="form-field required-field" data-test-id="email">
                        <label htmlFor="email">
                            <sup className="required">*</sup>Email
                        </label>
                        <input
                            required
                            className="inputEleWidth"
                            type="text"
                            name="Email"
                            id="email"
                            value={payer.Email || ''}
                            onChange={handleInputChange}
                        />
                    </span>
                </div>
                <div className="row">
                    <span className="form-field required-field" data-test-id="residency">
                        <label htmlFor="residency">
                            <sup className="required">*</sup>Residency
                        </label>
                        <select
                            required
                            value={payer.countryCode}
                            name="countryCode"
                            id="residency"
                            className="dropDownWidth"
                            onChange={(e) => {
                                let _states = this.getStatesByCountry(e.target.value) || [];
                                this.setState({ country: e.target.value, _states });
                                handleInputChange(e);
                            }}>
                            <option value="">Select One</option>
                            <option value="US">United States</option>
                            <option value="AU">Australia</option>
                            <option value="CA">Canada</option>
                            <option value="NZ">New Zealand</option>
                            <option value="GB">United Kingdom</option>
                            <option value="--" disabled="">
                                ------------------------------------------------
                            </option>
                            {countries.length > 0 &&
                                countries.map((country) => {
                                    let countryCode = country.code,
                                        countryName = country.name;
                                    return <option value={countryCode}>{countryName}</option>;
                                })}
                        </select>
                    </span>
                </div>
                {country === 'GB' || country === 'UK' ? (
                    <div className="row">
                        <span className="form-field required-field" data-test-id="house-name">
                            <label htmlFor="housename">House Name</label>
                            <input
                                className="inputEleWidth"
                                type="text"
                                name="Housename"
                                id="housename"
                                value={payer.Housename || ''}
                                onChange={handleInputChange}
                            />
                        </span>
                    </div>
                ) : null}
                <div className="row">
                    <span className="form-field required-field" data-test-id="address">
                        <label htmlFor="address">
                            <sup className="required">*</sup>
                            {country === 'HK' ? 'Address 1' : 'Address'}
                        </label>
                        <input
                            required
                            className="inputEleWidth"
                            type="text"
                            name="Address"
                            id="address"
                            value={payer.Address || ''}
                            onChange={handleInputChange}
                        />
                    </span>
                    {country === 'HK' && (
                        <div className="hk-help-text">
                            (Apartment, Flat, Room, Unit, No., House, Floor, Building, Mansion,
                            Court, House)
                        </div>
                    )}
                </div>
                {country === 'CA' ||
                country === 'MX' ||
                country === 'PR' ||
                country === 'US' ||
                country === 'VI' ? null : (
                    <div className="row">
                        <span className="form-field required-field" data-test-id="address2">
                            <label htmlFor="address2">Address 2</label>
                            <input
                                className="inputEleWidth"
                                type="text"
                                name="Address2"
                                id="address2"
                                value={payer.Address2 || ''}
                                onChange={handleInputChange}
                            />
                        </span>
                        {country === 'HK' && (
                            <div className="hk-help-text">
                                (Block, Tower, Estate, Village, Court, Others)
                            </div>
                        )}
                    </div>
                )}
                {country === 'GB' || country === 'UK' || country === 'HK' ? (
                    <div className="row">
                        <span className="form-field required-field" data-test-id="address3">
                            <label htmlFor="address3">Address 3</label>
                            <input
                                className="inputEleWidth"
                                type="text"
                                name="Address3"
                                id="address3"
                                value={payer.Address3 || ''}
                                onChange={handleInputChange}
                            />
                        </span>
                        {country === 'HK' && (
                            <div className="hk-help-text">(Street Number, Street Name)</div>
                        )}
                    </div>
                ) : null}
                {country === 'HK' ? (
                    <>
                        <div className="row">
                            <span className="form-field required-field" data-test-id="city">
                                <label htmlFor="city">
                                    <sup className="required">*</sup>District
                                </label>
                                <select
                                    required
                                    value={payer.City || ''}
                                    name="City"
                                    id="city"
                                    className={`inputEleWidth font-size-p0 gotham-book`}
                                    onChange={handleInputChange}>
                                    <option value="">Select One</option>
                                    {districts[0].states.map((dis) => (
                                        <option value={dis.stateCode}>{dis.stateDesc}</option>
                                    ))}
                                </select>
                            </span>
                        </div>
                        <div className="row">
                            <span className="form-field required-field" data-test-id="city">
                                <label htmlFor="zone">
                                    <sup className="required">*</sup>Zone
                                </label>
                                <select
                                    required
                                    value={payer.stateCode}
                                    name="stateCode"
                                    id="zone"
                                    className={`inputEleWidth font-size-p0 gotham-book`}
                                    onChange={handleInputChange}>
                                    <option value="">Select One</option>
                                    {zones[0].states.map((zone) => (
                                        <option value={zone.stateCode}>{zone.stateDesc}</option>
                                    ))}
                                </select>
                            </span>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="row">
                            <span className="form-field required-field" data-test-id="city">
                                <label htmlFor="city">
                                    <sup className="required">*</sup>
                                    {country === 'AU' || country === 'NZ' ? 'Suburb' : 'City'}
                                </label>
                                <input
                                    required
                                    className="inputEleWidth"
                                    type="text"
                                    name="City"
                                    id="city"
                                    value={payer.City || ''}
                                    onChange={handleInputChange}
                                />
                            </span>
                        </div>

                        <div className="row">
                            {_states && _states.length > 0 ? (
                                <span className="form-field required-field billing_state-select">
                                    <label htmlFor="stateCode">
                                        <sup className="required">*</sup>
                                        <span
                                            className="label-text"
                                            data-default="State/Province"
                                            data-uk="County">
                                            State/Province
                                        </span>
                                    </label>
                                    <select
                                        required
                                        value={payer.stateCode}
                                        name="stateCode"
                                        id="stateCode"
                                        className={`inputEleWidth font-size-p0 gotham-book`}
                                        onChange={handleInputChange}>
                                        <option value="">Select One</option>
                                        {_states.map((_state) => (
                                            <option value={_state.v}>{_state.n}</option>
                                        ))}
                                    </select>
                                </span>
                            ) : (
                                <span className="form-field required-field billing_state">
                                    <label htmlFor="stateCode">
                                        <sup className="required">*</sup>
                                        <span
                                            className="label-text"
                                            data-default="State/Province"
                                            data-uk="County">
                                            {country === 'GB' || country === 'UK'
                                                ? 'County'
                                                : 'State/Province'}
                                        </span>
                                    </label>
                                    <input
                                        required
                                        value={payer.stateCode}
                                        className={`inputEleWidth`}
                                        onChange={handleInputChange}
                                        type="text"
                                        name="stateCode"
                                        id="stateCode"
                                    />
                                </span>
                            )}
                        </div>
                    </>
                )}

                {/* <div className="row">{this.props.getStateField(payer.countryCode)}</div> */}
                <div className="row">
                    <span className="form-field required-field" data-test-id="zip-code">
                        <label htmlFor="zipPostalCode">
                            <sup className="required">*</sup>Zip/Postal Code
                        </label>
                        <input
                            required
                            className="inputEleWidth"
                            type="text"
                            name="PostCode"
                            id="zipPostalCode"
                            value={payer.PostCode || ''}
                            onChange={handleInputChange}
                        />
                    </span>
                </div>
                <div
                    id="spa-mcErrorContainer"
                    class="alert hidden col-xs-12 row bottom-spacing-10"
                    role="alert"></div>
                <div className="row form-field">
                    <span>Cards We Accept</span>
                </div>
                <div className="row">
                    <span className="form-field ccType">
                        <span className="pc-icons visa-24">Visa </span>
                        <span className="pc-icons mc-24">Master Card </span>
                        <span className="pc-icons discover-24">Discover </span>
                        <span className="pc-icons dinners-24">Dinners </span>
                        <span className="pc-icons amex-24">American Express </span>
                    </span>
                </div>
                <div className="row">
                    <span className="form-field required-field" data-test-id="card-number">
                        <label htmlFor="cardNumber">
                            <sup className="required">*</sup>Card Number
                        </label>
                        <input
                            required
                            className="inputEleWidth"
                            type="text"
                            name="CardNumber"
                            id="cardNumber"
                            value={payer.CardNumber || ''}
                            onChange={handleInputChange}
                        />
                    </span>
                </div>
                <div className="row">
                    <span className="form-field required-field" data-test-id="security-code">
                        <label htmlFor="securityCode">
                            <sup className="required">*</sup>Security Code
                        </label>
                        <input
                            required
                            className="securityCodeWidth"
                            type="text"
                            name="CardCode"
                            id="securityCode"
                            value={payer.CardCode}
                            onChange={handleInputChange}
                        />
                        <span className="help">
                            <Popup
                                ref="helpPopUp"
                                trigger={
                                    <input
                                        className="button-link"
                                        type="button"
                                        onClick={this.help}
                                        value="Help"></input>
                                }
                                modal
                                defaultOpen={false}
                                closeOnDocumentClick>
                                {this.helpPopUp}
                            </Popup>
                            <span className="questionMark pc-icons blue-circle-qmark-16"></span>
                        </span>
                    </span>
                </div>
                <div className="row">
                    <span className="expirationWidth form-field required-field">
                        <label htmlFor="month">
                            <sup className="required">*</sup>Expiration Date
                        </label>
                        <select
                            required
                            value={payer.expMonth}
                            className="expirationDropDownWidth expirationMargin font-size-p0 gotham-book"
                            onChange={handleInputChange}
                            name="expMonth"
                            id="month"
                            defaultValue="01"
                            data-test-id="expiration-month">
                            <option defaultValue=""></option>
                            {months.map((month) => (
                                <option value={month.value}>{month.name}</option>
                            ))}
                        </select>
                        <select
                            required
                            value={payer.expYear}
                            className="expirationDropDownWidth font-size-p0 gotham-book"
                            name="expYear"
                            onChange={handleInputChange}
                            defaultValue={new Date()
                                .getFullYear()
                                .toString()
                                .substr(-2)}
                            id="year"
                            data-test-id="expiration-year">
                            <option defaultValue=""></option>
                            {years.map((year) => (
                                <option value={year.value}>{year.name}</option>
                            ))}
                        </select>
                    </span>
                </div>
                <div className="row form-field" data-test-id="total-balance">
                    <span className="font-size-p11 gotham-xn-medium">
                        Total Balance Due:{' '}
                        <sup className="font-size-14">{`${
                            ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'
                        } `}</sup>
                        {` ${cartPrice}`}
                    </span>
                </div>
                {isPayLoading ? (
                    <span className="spa-loading-text-container payment-loader-text">
                        <img alt="Loader-spinner" width="25px" height="25px" src={LoaderImg} />
                        <span className="services-loading-text font-size-p5 gotham-xn-medium">
                            Processing
                        </span>
                    </span>
                ) : (
                    <div className="row form-field">
                        <input
                            type="button"
                            data-test-id="payment-button"
                            onClick={this.handlePayment}
                            defaultValue="Submit Payment"
                            className="payment-submit-btn col-sm-7 button primary-btn btn-dark-bg font-size-p5 gotham-xn-medium"></input>
                    </div>
                )}
                <input type="text" name="fundsType" id="fund-type" className="visuallyhidden" />
                <input
                    type="text"
                    name="maskedCardNumber"
                    id="maskedCardNumber"
                    className="visuallyhidden"
                />
                <input
                    type="text"
                    name="cardStringType"
                    id="cardStringType"
                    className="visuallyhidden"
                />
            </form>
        );
    }
}

export default PaymentForm;
